export class Organization {
    public id = 0
    public name = ''

    constructor() { }
}